import { useQuery } from "react-query";
import { useMutation, useQueryClient } from "react-query";
import {
  getFranchiseList,
  getFranchiseDetails,
  addFranchise,
  updateFranchise,
  getFranchiseWalletOrdersList,
  getFranchiseWalletTransactionsList,
  addWalletOrder,
  verifyWalletTransaction,
  retryWalletTransaction,
  getCurrentFranchise,
  createWalletTopUp,
  // deleteCategory,
} from "./franchiseUrls";

const Get_current_franchise = (query) => {
  console.log(query)
  return useQuery(["currentFranchise"], () => getCurrentFranchise(), {
    refetchOnWindowFocus: false,
    enabled: query.userType === 'regional_admin' ? true : false
  });
};

const Franchise_list = (query) => {
  return useQuery(["franchiseList", query], () => getFranchiseList(query), {
    refetchOnWindowFocus: false,
    poll: 500,
  });
};

const Franchise_details = (id) => {
  return useQuery(["franchiseDetails", id], () => getFranchiseDetails(id), {
    refetchOnWindowFocus: false,
    poll: 500,
    enabled: !!id
  });
};

const Add_franchise = () => {
  const queryClient = useQueryClient();
  return useMutation((franchise) => addFranchise(franchise), {
    onMutate: async (newFranchise) => {
      await queryClient.cancelQueries("franchiseList");
      const prev = queryClient.getQueryData("franchiseList");
      return {
        prev,
        newFranchise,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("franchiseList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("franchiseList", context.prev);
    },
  });
};

const Edit_franchise = () => {
  const queryClient = useQueryClient();
  return useMutation((franchise) => updateFranchise(franchise), {
    onMutate: async (newFranchise) => {
      await queryClient.cancelQueries("franchiseList");
      const prev = queryClient.getQueryData("franchiseList");
      return {
        prev,
        newFranchise,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("franchiseList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("franchiseList", context.prev);
    },
  });
};

const Franchise_Wallet_Orders_List = (query) => {
  return useQuery(["walletOrdersList", query], () => getFranchiseWalletOrdersList(query), {
    refetchOnWindowFocus: false,
  });
};

const Franchise_Wallet_Transactions_List = (query) => {
  return useQuery(["walletTransactionsList", query], () => getFranchiseWalletTransactionsList(query), {
    refetchOnWindowFocus: false,
  });
};

const CreateWalletTopUp = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createWalletTopUp(data), {
    onMutate: async (newFranchise) => {
      await queryClient.cancelQueries("walletTransactionsList");
      const prev = queryClient.getQueryData("walletTransactionsList");
      return {
        prev,
        newFranchise,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("walletTransactionsList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("walletTransactionsList", context.prev);
    },
  });
};

const Add_Wallet_Order = () => {
  const queryClient = useQueryClient();
  return useMutation((franchise) => addWalletOrder(franchise), {
    onMutate: async (newFranchise) => {
      await queryClient.cancelQueries("walletOrdersList");
      const prev = queryClient.getQueryData("walletOrdersList");
      return {
        prev,
        newFranchise,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("walletOrdersList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("walletOrdersList", context.prev);
    },
  });
};

const Verify_Wallet_Transactions = () => {
  const queryClient = useQueryClient();
  return useMutation((franchise) => verifyWalletTransaction(franchise), {
    onMutate: async (newFranchise) => {
      await queryClient.cancelQueries("walletTransactionsList");
      const prev = queryClient.getQueryData("walletTransactionsList");
      return {
        prev,
        newFranchise,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("walletTransactionsList");
      queryClient.invalidateQueries("franchiseDetails");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("walletTransactionsList", context.prev);
    },
  });
};

const Retry_Wallet_Transactions = () => {
  const queryClient = useQueryClient();
  return useMutation((franchise) => retryWalletTransaction(franchise), {
    onMutate: async (newFranchise) => {
      await queryClient.cancelQueries("walletTransactionsList");
      const prev = queryClient.getQueryData("walletTransactionsList");
      return {
        prev,
        newFranchise,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("walletTransactionsList");
      queryClient.invalidateQueries("franchiseDetails");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("walletTransactionsList", context.prev);
    },
  });
};

const useFranchiseQuery = {
  Franchise_list,
  Franchise_details,
  Add_franchise,
  Edit_franchise,
  Franchise_Wallet_Orders_List,
  Franchise_Wallet_Transactions_List,
  Add_Wallet_Order,
  Verify_Wallet_Transactions,
  Retry_Wallet_Transactions,
  Get_current_franchise,
  CreateWalletTopUp
};

export default useFranchiseQuery;
